module.exports = __webpack_public_path__ + "media/37.de99c4f3.mp3";